export const languageSpecificConfig: Record<'cs' | 'en' | 'de', any> = {
    cs: {
        SITE_URL: 'https://www.ackee.cz',
    },
    de: {
        SITE_URL: 'https://www.ackee.de',
    },
    en: {
        SITE_URL: 'https://www.ackee.agency',
    },
};

export type Language = keyof typeof languageSpecificConfig;
